import request from '@/utils/request'
import axios from 'axios';
import { resolveBlob } from '../../utils/zipdownload';

export function recordPV(query) {
    return request({
        url: '/pageView/record',
        method: 'post',
        data: query
    })
}




// WEBPACK FOOTER //
// ./src/api/system/pageView.js